"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEGRADETYPE;
(function (DEGRADETYPE) {
    // 出行攻略
    DEGRADETYPE[DEGRADETYPE["STRATEGY"] = 1] = "STRATEGY";
    // 项目推荐
    DEGRADETYPE[DEGRADETYPE["RECOMMEND"] = 2] = "RECOMMEND";
    // 衍生品
    DEGRADETYPE[DEGRADETYPE["DERIVATION"] = 3] = "DERIVATION";
    // 评论
    DEGRADETYPE[DEGRADETYPE["COMMENT"] = 4] = "COMMENT";
    // 弹窗
    DEGRADETYPE[DEGRADETYPE["POPUP"] = 5] = "POPUP";
    // 收藏
    DEGRADETYPE[DEGRADETYPE["FAVOR"] = 6] = "FAVOR";
    // 票档算价
    DEGRADETYPE[DEGRADETYPE["CALPRICE"] = 7] = "CALPRICE";
})(DEGRADETYPE || (DEGRADETYPE = {}));
exports.default = DEGRADETYPE;
